import { FormField } from 'components/shared/form';
import { divide } from 'shared/utils/numberOperations';

export const financingTermsFormFields: FormField[] = [
  {
    name: 'financingTerms',
    fields: [
      {
        name: 'hypothetical',
        fields: [
          { name: 'netOperatingIncome', type: 'number', value: 0 },
          { name: 'capRate', type: 'number', value: 0 },
          { name: 'loanToValue', type: 'number', value: 0 },
          { name: 'interestRate', type: 'number', value: 0 },
          { name: 'loanTerm', type: 'number', value: 0 },
        ],
      },
      {
        name: 'borrower',
        fields: [
          { name: 'capRate', type: 'number', value: 0 },
          { name: 'loanToValue', type: 'number', value: 0 },
          { name: 'interestRate', type: 'number', value: 0 },
          { name: 'loanTerm', type: 'number', value: 0 },
        ],
      },
      {
        name: 'underwriter',
        fields: [
          { name: 'capRate', type: 'number', value: 0 },
          { name: 'loanToValue', type: 'number', value: 0 },
          { name: 'interestRate', type: 'number', value: 0 },
          { name: 'loanTerm', type: 'number', value: 0 },
        ],
      },
    ],
  },
];

export const financingTermsFormHelpers = {
  calculateAppraisedValue(netOperatingIncome: number, capRate: number) {
    const capRatePercentage = divide(capRate, 100);
    return divide(netOperatingIncome, capRatePercentage);
  },
  calculateLoanAmount(netOperatingIncome: number, capRate: number, loanToValue: number) {
    const appraisedValue = financingTermsFormHelpers.calculateAppraisedValue(netOperatingIncome, capRate);
    const loanToValuePercentage = divide(loanToValue, 100);
    return appraisedValue * loanToValuePercentage;
  },
  calculateDebtService(loanAmount: number, interestRate: number, loanTerm: number) {
    const interestRateMonthly = divide(interestRate / 100, 12);
    const loanTermMonthly = loanTerm * 12;
    const dividend = interestRateMonthly * loanAmount * Math.pow(1 + interestRateMonthly, loanTermMonthly);
    const divisor = Math.pow(1 + interestRateMonthly, loanTermMonthly) - 1;
    return divide(dividend, divisor) * 12;
  },
  calculateDebtServiceCoverageRatio(netOperatingIncome: number, debtService: number) {
    return divide(netOperatingIncome, debtService);
  },
};
